const getBrandsConfigs = (state) => state.brandingReducer;

export const selectBrandsConfig = (state) => getBrandsConfigs(state);